import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import classnames from "classnames";

export class Portal extends Component {
  constructor (props) {
    super(props);

    this.parent = document.getElementById(this.props.parentId || "gb-main");
    this.element = document.createElement("div");
  }

  componentDidMount () {
    this.parent.appendChild(this.element);
  }

  componentWillUnmount () {
    this.parent.removeChild(this.element);
  }

  render () {
    const { props } = this;

    this.element.id = props.id;
    this.element.className = classnames(props.className);

    return ReactDOM.createPortal(
      props.children,
      this.element
    );
  }
}

Portal.defaultProps = {
  parentId: "gb-main",
  id: "",
  children: null,
  className: ""
};

Portal.propTypes = {
  parentId: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};
